import React, { useEffect, useRef, useState } from "react";
import Input from "../UniversalComponents/InputComponent";
import { ReactComponent as ClosePopUpIcn } from "../../assets/images/closePopUpIcn.svg";
import { ReactComponent as DownAngelBracket } from "../../assets/images/downAngleBracket.svg";
import { ReactComponent as CalendarWithTimeIcon } from "../../assets/images/calendarWithTimeIcon.svg";
import Select from "../../components/UniversalComponents/SelectComponent";
import DatePicker from "react-datepicker";
import NameContact from "../../assets/images/icons/NameContact";
import LocationIcon from "../../assets/images/icons/LocationIcon";
import NotesAttachment from "../../assets/images/icons/NotesAttachment";
import BalleteIcon from "../../assets/images/icons/BalleteIcon";
import AdditionalInfoIcon1 from "../../assets/images/icons/AdditionalInfoIcon1";

const NewClient = () => {
  const [isAddClientVisible, setIsAddClientVisible] = useState(false);
  const [isContactFormVisible, setIsContactFormVisible] = useState(false);
  const [isAddressFormVisible, setIsAddressFormVisible] = useState(false);
  const [isPaymentTabVisible, setIsPaymentTabVisible] = useState(false);
  const [isAddiInfoTabVisible, setIsAddiInfoTabVisible] = useState(false);
  const [isNotesVisible, setIsNotesVisible] = useState(false);
  const [isContactFormOpen, setIsContactFormOpen] = useState(false);
  const [isAddressFormOpen, setIsAddressFormOpen] = useState(false);
  const [isPaymentTabOpen, setIsPaymentTabOpen] = useState(false);
  const [isAddiInfoTabOpen, setIsAddiInfoTabOpen] = useState(false);
  const [isNotesOpen, setIsNotesOpen] = useState(false);
  const [inputCompanyValue, setInputCompanyValue] = useState("");
  const [inputAdd1Value, setInputAdd1Value] = useState("");
  // const [inputAccountNumber, setInputAccountNumber] = useState("");
  const [inputOpeningBalace, setInputOpeningBalace] = useState("");
  const [inputTitleValue, setInputTitleValue] = useState("");
  const [inputSuffixValue, setInputSuffixValue] = useState("");
  const [inputPhoneNoValue, setInputPhoneNoValue] = useState("");
  const [inputStateValue, setInputStateValue] = useState("");
  const [inputCountryValue, setInputCountryValue] = useState("");
  const [inputFaxValue, setInputFaxValue] = useState("");
  const [inputWebsite, setInputWebsite] = useState("");
  const [inputListNameValue, setInputListNameValue] = useState("");
  const [inputEmailValue, setInputEmailValue] = useState("");
  const [inputCityValue, setInputCityValue] = useState("");
  const [inputZIPCodeValue, setInputZIPCodeValue] = useState("");
  const [inputAdd2Value, setInputAdd2Value] = useState("");
  // const [inputRountingValue, setInputRountingValue] = useState("");
  const [inputExempDetailValue, setInputExempDetailValue] = useState("");
  const [inputMobileNoValue, setInputMobileNoValue] = useState("");
  const [inputOtherValue, setInputOtherValue] = useState("");
  const [inputCompanyNameValue, setInputCompanyNameValue] = useState("");
  const [inputCreditLimitValue, setInputCreditLimitValue] = useState("");
  // const [inputBusinessIdValue, setInputBusinessIdValue] = useState("");
  const [inputMiddleName, setInputMiddleName] = useState("");
  const [inputFirstName, setInputFirstName] = useState("");
  const [selectedValue, setSelectedValue] = useState("");
  const [selectedClietValue, setSelectedClientValue] = useState("");
  const [selectedSalesValue, setSelecteSalesdValue] = useState("");
  // const [selectedTermValue, setSelectedTermValue] = useState("");
  const [selecteAddInfTermValue, setSelectedAddInfTermValue] = useState("");
  const [selectePayTermValue, setSelectedPayTermValue] = useState("");
  const [selectedLanguageValue, setSelectedLanguageValue] = useState("");
  // const [selectedDefaultExCateValue, setSelectedDefaultExCateValue] = useState("");
  const [OpeningBalanceDate, setOpeningBalanceDate] = useState(null);
  const placeholder = "Select Date";
  const displayFormat = "dd-MM-yyyy";
  const nameTabRef = useRef(null);
  const locationTabRef = useRef(null);
  const notesTabRef = useRef(null);
  const paymentTabRef = useRef(null);
  const additionalInfTabRef = useRef(null);

  useEffect(() => {
    if (isNotesOpen) handleNotesScrollToSection();
  }, [isNotesOpen]);

  useEffect(() => {
    if (isContactFormOpen) handleNameScrollToSection();
  }, [isContactFormOpen]);

  useEffect(() => {
    if (isAddressFormOpen) handleLocationScrollToSection();
  }, [isAddressFormOpen]);

  useEffect(() => {
    if (isPaymentTabOpen) handleBalletScrollToSection();
  }, [isPaymentTabOpen]);

  useEffect(() => {
    if (isPaymentTabOpen) handleBalletScrollToSection();
  }, [isPaymentTabOpen]);

  useEffect(() => {
    if (isAddiInfoTabOpen) handleAdditionalTabScrollToSection();
  }, [isAddiInfoTabOpen]);

  const closeAddVendor = () => {
    setIsAddClientVisible(false);
  };

  const toggleContactFormVisibility = (e) => {
    e.preventDefault();
    setIsContactFormVisible((prev) => !prev);
    setIsContactFormOpen((prevState) => !prevState);
  };
  const toggleAddressFormVisibility = (e) => {
    e.preventDefault();
    setIsAddressFormVisible((prev) => !prev);
    setIsAddressFormOpen((prevState) => !prevState);
  };
  const togglePaymentVisibility = (e) => {
    e.preventDefault();
    setIsPaymentTabVisible((prev) => !prev);
    setIsPaymentTabOpen((prevState) => !prevState);
  };
  const toggleAddiInfVisibility = (e) => {
    e.preventDefault();
    setIsAddiInfoTabVisible((prev) => !prev);
    setIsAddiInfoTabOpen((prevState) => !prevState);
  };
  const toggleNotesVisibility = (e) => {
    e.preventDefault();
    setIsNotesVisible((prev) => !prev);
    setIsNotesOpen((prevState) => !prevState);
  };

  const handleCompanyInputChange = (e) => {
    setInputCompanyValue(e.target.value);
  };
  const handleAdd1InputChange = (e) => {
    setInputAdd1Value(e.target.value);
  };
  const handleBankAccNumberInputChange = (e) => {
    setInputOpeningBalace(e.target.value);
  };

  const handleTitleInputChange = (e) => {
    setInputTitleValue(e.target.value);
  };
  const handleSuffixInputChange = (e) => {
    setInputSuffixValue(e.target.value);
  };
  const handlePhoneNoInputChange = (e) => {
    setInputPhoneNoValue(e.target.value);
  };
  const handleStateInputChange = (e) => {
    setInputStateValue(e.target.value);
  };
  const handleCountryInputChange = (e) => {
    setInputCountryValue(e.target.value);
  };
  const handleFaxInputChange = (e) => {
    setInputFaxValue(e.target.value);
  };
  const handleWebsiteInputChange = (e) => {
    setInputWebsite(e.target.value);
  };
  const handleLastNameInputChange = (e) => {
    setInputListNameValue(e.target.value);
  };
  const handleEmailInputChange = (e) => {
    setInputEmailValue(e.target.value);
  };
  const handleCityInputChange = (e) => {
    setInputCityValue(e.target.value);
  };
  const handleZIPCodeInputChange = (e) => {
    setInputZIPCodeValue(e.target.value);
  };
  const handleAdd2InputChange = (e) => {
    setInputAdd2Value(e.target.value);
  };
  // const handleRountingInputChange = (e) => {
  //     setInputRountingValue(e.target.value);
  // };
  const handleExempDetailChange = (e) => {
    setInputExempDetailValue(e.target.value);
  };
  const handleMobileNoInputChange = (e) => {
    setInputMobileNoValue(e.target.value);
  };
  const handleOtherInputChange = (e) => {
    setInputOtherValue(e.target.value);
  };
  const handleCompanyNameInputChange = (e) => {
    setInputCompanyNameValue(e.target.value);
  };
  const handleCreditLimitInputChange = (e) => {
    setInputCreditLimitValue(e.target.value);
  };
  // const handleBusinessIdInputChange = (e) => {
  //     setInputBusinessIdValue(e.target.value);
  // };
  const handleMiddleNameInputChange = (e) => {
    setInputMiddleName(e.target.value);
  };
  const handleFirstNameInputChange = (e) => {
    setInputFirstName(e.target.value);
  };

  const selectVendoerDisplayName = [
    // { label: "Who did you Pay ?" },
    { value: "option2", label: "Option 2" },
    { value: "option3", label: "Option 3" },
  ];
  const selectPPMName = [
    // { label: "Who did you Pay ?" },
    { value: "option2", label: "Option 2" },
    { value: "option3", label: "Option 3" },
  ];
  const selectClientType = [
    // { label: "Who did you Pay ?" },
    { value: "option2", label: "Option 2" },
    { value: "option3", label: "Option 3" },
  ];
  const selectSalesFDPName = [
    // { label: "Who did you Pay ?" },
    { value: "option2", label: "Option 2" },
    { value: "option3", label: "Option 3" },
  ];
  const selectAddInfoTermNames = [
    // { label: "Who did you Pay ?" },
    { value: "option2", label: "Option 2" },
    { value: "option3", label: "Option 3" },
  ];
  const selectPayTermsNames = [
    // { label: "Who did you Pay ?" },
    { value: "option2", label: "Option 2" },
    { value: "option3", label: "Option 3" },
  ];
  const selectLanguage = [
    // { label: "Who did you Pay ?" },
    { value: "option2", label: "Option 2" },
    { value: "option3", label: "Option 3" },
  ];
  const selectDefaultExCategory = [
    // { label: "Who did you Pay ?" },
    { value: "option2", label: "Option 2" },
    { value: "option3", label: "Option 3" },
  ];

  const handleAddInfTermSelectChange = (e) => {
    setSelectedAddInfTermValue(e.target.value);
  };
  const handlePayTermSelectChange = (e) => {
    setSelectedPayTermValue(e.target.value);
  };
  const handleLanguageSelectChange = (e) => {
    setSelectedLanguageValue(e.target.value);
  };
  // const handleDefaultExCateSelectChange = (e) => {
  //     setSelectedDefaultExCateValue(e.target.value);
  // };
  const handleVendorSelectChange = (e) => {
    setSelectedValue(e.target.value);
  };
  const handlePPMSelectChange = (e) => {
    setSelectedValue(e.target.value);
  };
  const handleClientTypeSelectChange = (e) => {
    setSelectedClientValue(e.target.value);
  };
  const handSalesFDPSelectChange = (e) => {
    setSelecteSalesdValue(e.target.value);
  };

  const formatDateForSaveAsOf = (date) => {
    if (!date) return "";
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, "0");
    const day = `${date.getDate()}`.padStart(2, "0");
    return `${day}-${month}-${year}`;
  };

  const onChange = (date) => {
    setOpeningBalanceDate(date);

    const formattedPaymentDate = date ? formatDateForSaveAsOf(date) : "";

    // FieldChange({ payment_date: formattedPaymentDate });
  };

  const handleNameScrollToSection = () => {
    nameTabRef?.current?.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  };
  const handleLocationScrollToSection = () => {
    locationTabRef?.current?.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  };
  const handleNotesScrollToSection = () => {
    notesTabRef?.current?.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  };
  const handleBalletScrollToSection = () => {
    paymentTabRef?.current?.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  };
  const handleAdditionalTabScrollToSection = () => {
    additionalInfTabRef?.current?.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  };

  return (
    <div className="">
      {/* <div>Icons</div> */}
      <div className=" bg-FFFFFF p-6 pl-4">
        <div className="flex justify-between border-b-2 ml-12 pb-2 mb-2">
          <div className="text-16 font-500 text-203C50 align-text-bottom">Client</div>
          <div className="bg-F1F5F8 m-1 px-1 align-top">
            <button onClose={closeAddVendor}>
              <ClosePopUpIcn />
            </button>
          </div>
        </div>
        <div className="flex space-x-4 ">
          <div className="flex flex-col space-y-2">
            <button
              onClick={(e) => {
                toggleContactFormVisibility(e);
                handleNameScrollToSection();
              }}
            >
              <NameContact />
            </button>
            <button
              onClick={(e) => {
                toggleAddressFormVisibility(e);
                handleLocationScrollToSection();
              }}
            >
              <LocationIcon />
            </button>
            <button
              onClick={(e) => {
                toggleNotesVisibility(e);
              }}
            >
              <NotesAttachment />
            </button>
            <button
              onClick={(e) => {
                togglePaymentVisibility(e);
                handleBalletScrollToSection();
              }}
            >
              <BalleteIcon />
            </button>
            <button
              onClick={(e) => {
                toggleAddiInfVisibility(e);
                handleAdditionalTabScrollToSection();
              }}
            >
              <AdditionalInfoIcon1 />
            </button>
          </div>
          <div className="w-[652px] flex flex-col space-y-[20px] h-[90vh] overflow-y-scroll customscrollbar">
            <div className="border">
              <div className="flex justify-between items-center bg-E4E6E8 p-3 border">
                <div className="text-16 font-500">Name & contact</div>
                <div>
                  <button
                    onClick={(e) => {
                      toggleContactFormVisibility(e);
                    }}
                  >
                    <DownAngelBracket
                      className={`h-[8px] text-1D4469 sidedownarrow  items-center ${
                        isContactFormOpen ? "" : "rotate-180"
                      }`}
                    />
                  </button>
                </div>
              </div>
              {isContactFormVisible && (
                <div className="p-5" ref={nameTabRef}>
                  <div className="flex flex-col gap-y-[20px]">
                    <div className="w-full flex gap-x-2">
                      <div className="flex flex-col gap-y-1">
                        <div className="text-14 font-500 text-434852">Title</div>

                        <div>
                          <Input
                            name="title"
                            // label="Enter Text"
                            // placeholder="Start Typing To Add A Tag"
                            value={inputTitleValue} // Bind the input value to the state
                            onChange={handleTitleInputChange} // Handle the change event
                            style={{ width: "100%", height: "35px" }} // Additional styling if needed
                          ></Input>
                        </div>
                      </div>
                      <div className="flex flex-col gap-y-1">
                        <div className="text-14 font-500 text-434852">FirstName</div>

                        <div>
                          <Input
                            name="Firstname"
                            // label="Enter Text"
                            // placeholder="Start Typing To Add A Tag"
                            value={inputFirstName} // Bind the input value to the state
                            onChange={handleFirstNameInputChange} // Handle the change event
                            style={{ width: "100%", height: "35px" }} // Additional styling if needed
                          ></Input>
                        </div>
                      </div>
                      <div className="flex flex-col gap-y-1">
                        <div className="text-14 font-500 text-434852">Middle Name</div>

                        <div>
                          <Input
                            name="middlename"
                            // label="Enter Text"
                            // placeholder="Start Typing To Add A Tag"
                            value={inputMiddleName} // Bind the input value to the state
                            onChange={handleMiddleNameInputChange} // Handle the change event
                            style={{ width: "100%", height: "35px" }} // Additional styling if needed
                          ></Input>
                        </div>
                      </div>
                      <div className="flex flex-col gap-y-1">
                        <div className="text-14 font-500 text-434852">Last Name</div>

                        <div>
                          <Input
                            name="lastname"
                            // label="Enter Text"
                            // placeholder="Start Typing To Add A Tag"
                            value={inputListNameValue} // Bind the input value to the state
                            onChange={handleLastNameInputChange} // Handle the change event
                            style={{ width: "100%", height: "35px" }} // Additional styling if needed
                          ></Input>
                        </div>
                      </div>
                      <div className="flex flex-col gap-y-1">
                        <div className="text-14 font-500 text-434852">Suffix</div>

                        <div>
                          <Input
                            name="suffix"
                            // label="Enter Text"
                            // placeholder="Start Typing To Add A Tag"
                            value={inputSuffixValue} // Bind the input value to the state
                            onChange={handleSuffixInputChange} // Handle the change event
                            style={{ width: "100%", height: "35px" }} // Additional styling if needed
                          ></Input>
                        </div>
                      </div>
                    </div>
                    <div className="w-full flex items-center space-x-4">
                      <div className=" w-full">
                        <div className="flex flex-col gap-y-1">
                          <div className="text-14 font-400 text-434852">Company Name</div>

                          <div>
                            <Input
                              name="CompanyName"
                              label="Enter Text"
                              placeholder="Enter Company Name"
                              value={inputCompanyValue} // Bind the input value to the state
                              onChange={handleCompanyInputChange} // Handle the change event
                              style={{ width: "100%", height: "35px" }} // Additional styling if needed
                            ></Input>
                          </div>
                        </div>
                      </div>
                      <div className="w-full flex flex-col gap-y-1">
                        <div className="text-14 font-400 text-434852">Client Display Name</div>
                        <div className="w-full">
                          <Select
                            name="vendordispalyselect"
                            options={selectVendoerDisplayName} // Pass the options array
                            value={selectedValue} // Bind the selected value to the state
                            onChange={handleVendorSelectChange} // Handle the change event
                            style={{
                              width: "100%",
                              height: "35px",
                              padding: "5px",
                            }}
                            className="w-full"
                          ></Select>
                        </div>
                      </div>
                    </div>

                    <div className="w-full flex gap-x-4">
                      <div className=" w-full flex flex-col gap-y-1">
                        <div className="text-14 font-400 text-434852">Email </div>

                        <div>
                          <Input
                            name="email"
                            // label="dkd"
                            placeholder="Enter Email"
                            value={inputEmailValue} // Bind the input value to the state
                            onChange={handleEmailInputChange} // Handle the change event
                            style={{ width: "100%", height: "35px" }} // Additional styling if needed
                          ></Input>
                        </div>
                      </div>
                      <div className="flex flex-col gap-y-1 w-full">
                        <div className="text-14 font-400 text-434852">Phone Number</div>

                        <div>
                          <Input
                            name="phonenumber"
                            // label="Enter Text"
                            placeholder="Enter Phone Number"
                            type={"number"}
                            value={inputPhoneNoValue} // Bind the input value to the state
                            onChange={handlePhoneNoInputChange} // Handle the change event
                            style={{ width: "100%", height: "35px" }} // Additional styling if needed
                          ></Input>
                        </div>
                      </div>
                    </div>
                    <div className="w-full flex gap-x-4">
                      <div className=" w-full flex flex-col gap-y-1">
                        <div className="text-14 font-400 text-434852">Mobile Number </div>

                        <div>
                          <Input
                            name="mobilenumber"
                            // label="dkd"
                            placeholder="Enter Mobile Number"
                            type={"number"}
                            value={inputMobileNoValue}
                            onChange={handleMobileNoInputChange}
                            style={{ width: "100%", height: "35px" }}
                          ></Input>
                        </div>
                      </div>
                      <div className="flex flex-col gap-y-1 w-full">
                        <div className="text-14 font-400 text-434852">Fax</div>

                        <div>
                          <Input
                            name="fax"
                            // label="Enter Text"
                            placeholder="Enter Fax"
                            value={inputFaxValue}
                            onChange={handleFaxInputChange}
                            style={{ width: "100%", height: "35px" }}
                          ></Input>
                        </div>
                      </div>
                    </div>
                    <div className="w-full flex gap-x-4">
                      <div className=" w-full flex flex-col gap-y-1">
                        <div className="text-14 font-400 text-434852">Other</div>

                        <div>
                          <Input
                            name="other"
                            // label="dkd"
                            placeholder="Enter Other Detail"
                            value={inputOtherValue}
                            onChange={handleOtherInputChange}
                            style={{ width: "100%", height: "35px" }}
                          ></Input>
                        </div>
                      </div>
                      <div className="flex flex-col gap-y-1 w-full">
                        <div className="text-14 font-400 text-434852">Website</div>

                        <div>
                          <Input
                            name="website"
                            // label="Enter Text"
                            placeholder="Enter Company Name"
                            value={inputWebsite}
                            onChange={handleWebsiteInputChange}
                            style={{ width: "100%", height: "35px" }}
                          ></Input>
                        </div>
                      </div>
                    </div>
                    <div className="w-full flex ">
                      <div className=" w-full flex flex-col gap-y-1">
                        <div className="text-14 font-400 text-434852 capitalize">Name to print on check</div>

                        <div>
                          <Input
                            name="nametoprintcheck"
                            // label="dkd"
                            placeholder="Enter Company Name"
                            value={inputCompanyNameValue}
                            onChange={handleCompanyNameInputChange}
                            style={{ width: "100%", height: "35px" }}
                          ></Input>
                        </div>
                      </div>
                    </div>
                    <div className="w-full flex ">
                      <div className=" w-full flex  gap-x-1 items-center">
                        <div className="space-x-2">
                          <input
                            type="checkbox"
                            className="appearance-none  text-12 focus:outline-none focus:ring-0 checked:bg-blue-500 checked:border-transparent border-[#D9D9D9]"
                            style={{ boxShadow: "none" }}
                          />

                          <span className="text-[#2C495D] text-12 font-400">Is a Sub-Client</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="border">
              <div className="flex justify-between items-center bg-E4E6E8 p-3 border">
                <div className="text-16 font-500">Addresses</div>
                <div>
                  <button
                    onClick={(e) => {
                      toggleAddressFormVisibility(e);
                    }}
                  >
                    <DownAngelBracket
                      className={`h-[8px] text-1D4469 sidedownarrow  items-center ${
                        isAddressFormOpen ? "" : "rotate-180"
                      }`}
                    />
                  </button>
                </div>
              </div>
              {isAddressFormVisible && (
                <div className="p-5" ref={locationTabRef}>
                  <div className="flex flex-col gap-y-[20px]">
                    <div className="w-full flex items-center space-x-4">
                      <div className=" w-full">
                        <div className="flex flex-col gap-y-1">
                          <div className="text-14 font-600 text-2C495D">Billing Address</div>
                        </div>
                      </div>
                    </div>
                    <div className="w-full flex items-center space-x-4">
                      <div className=" w-full">
                        <div className="flex flex-col gap-y-1">
                          <div className="text-14 font-400 text-434852">Street Address1</div>

                          <div>
                            <Input
                              name="street_add_1"
                              label="Enter Text"
                              placeholder="Enter Address"
                              value={inputAdd1Value} // Bind the input value to the state
                              onChange={handleAdd1InputChange} // Handle the change event
                              style={{ width: "100%", height: "35px" }} // Additional styling if needed
                            ></Input>
                          </div>
                        </div>
                      </div>
                      <div className=" w-full flex flex-col gap-y-1">
                        <div className="text-14 font-400 text-434852">Street Address2 </div>

                        <div>
                          <Input
                            name="address2"
                            // label="dkd"
                            placeholder="Enter Address"
                            value={inputAdd2Value} // Bind the input value to the state
                            onChange={handleAdd2InputChange} // Handle the change event
                            style={{ width: "100%", height: "35px" }} // Additional styling if needed
                          ></Input>
                        </div>
                      </div>
                    </div>

                    <div className="w-full flex gap-x-4">
                      <div className=" w-full flex flex-col gap-y-1">
                        <div className="text-14 font-400 text-434852">City </div>

                        <div>
                          <Input
                            name="city"
                            // label="dkd"
                            placeholder="Enter City"
                            value={inputCityValue} // Bind the input value to the state
                            onChange={handleCityInputChange} // Handle the change event
                            style={{ width: "100%", height: "35px" }} // Additional styling if needed
                          ></Input>
                        </div>
                      </div>
                      <div className="flex flex-col gap-y-1 w-full">
                        <div className="text-14 font-400 text-434852">State</div>

                        <div>
                          <Input
                            name="state"
                            // label="Enter Text"
                            placeholder="Enter State"
                            value={inputStateValue} // Bind the input value to the state
                            onChange={handleStateInputChange} // Handle the change event
                            style={{ width: "100%", height: "35px" }} // Additional styling if needed
                          ></Input>
                        </div>
                      </div>
                    </div>
                    <div className="w-full flex gap-x-4">
                      <div className=" w-full flex flex-col gap-y-1">
                        <div className="text-14 font-400 text-434852">ZIP Code </div>

                        <div>
                          <Input
                            name="zipcode"
                            // label="dkd"
                            placeholder="Enter Code"
                            type={"number"}
                            value={inputZIPCodeValue} // Bind the input value to the state
                            onChange={handleZIPCodeInputChange} // Handle the change event
                            style={{ width: "100%", height: "35px" }} // Additional styling if needed
                          ></Input>
                        </div>
                      </div>
                      <div className="flex flex-col gap-y-1 w-full">
                        <div className="text-14 font-400 text-434852">Country</div>

                        <div>
                          <Input
                            name="country"
                            // label="Enter Text"
                            placeholder="Enter Country"
                            value={inputCountryValue} // Bind the input value to the state
                            onChange={handleCountryInputChange} // Handle the change event
                            style={{ width: "100%", height: "35px" }} // Additional styling if needed
                          ></Input>
                        </div>
                      </div>
                    </div>
                    <div className="w-full flex items-center space-x-4">
                      <div className=" w-full">
                        <div className="flex flex-col gap-y-1">
                          <div className="text-14 font-600 text-2C495D">Shipping Address</div>
                        </div>
                      </div>
                    </div>
                    <div className="w-full flex ">
                      <div className=" w-full flex  gap-x-1 items-center">
                        <div className="space-x-2">
                          <input
                            type="checkbox"
                            className="appearance-none  text-12 focus:outline-none focus:ring-0 checked:bg-blue-500 checked:border-transparent border-[#D9D9D9]"
                            style={{ boxShadow: "none" }}
                          />

                          <span className="text-2C495D text-12 font-400">Same as Billing Address</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="border">
              <div className="flex justify-between items-center bg-E4E6E8 p-3 border">
                <div className="text-16 font-500">Notes & Attachments</div>
                <div>
                  <button
                    onClick={(e) => {
                      toggleNotesVisibility(e);
                    }}
                  >
                    <DownAngelBracket
                      className={`h-[8px] text-1D4469 sidedownarrow  items-center ${isNotesOpen ? "" : "rotate-180"}`}
                    />
                  </button>
                </div>
              </div>
              {isNotesVisible && (
                <div className="p-5" ref={notesTabRef}>
                  <div className="flex flex-col gap-y-[20px]">
                    <div className="w-full flex items-center space-x-4">
                      <div className=" w-full">
                        <div className="flex flex-col gap-y-[8px] w-full">
                          <div className="text-14 font-500 text-434852">Address</div>

                          <div className="h-[140px] text-14 font-400">
                            <textarea
                              rows="6"
                              cols="80.5"
                              placeholder="Enter Street Address"
                              className="focus:outline-hidden focus:ring-0 active:border active:border-DFE2E5 text-gray-800 text-sm  rounded border border-gray-200"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="w-full flex items-center space-x-4">
                      <div className=" w-full">
                        <div className="flex flex-col gap-y-[8px] w-full">
                          <div className="text-14 font-500 text-434852">PDF</div>

                          <div className="h-[140px] text-14 font-400 border border-DFE2E5 border-dashed rounded flex items-center justify-center">
                            <button className="text-12 font-400 flex flex-col items-center justify-center text-center">
                              <span className="text-2999BC">Add Attachments</span>
                              <span className="text-AFAFAF">Max File Size: 20 MB</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="border">
              <div className="flex justify-between items-center bg-E4E6E8 p-3 border">
                <div className="text-16 font-500">Payments</div>
                <div>
                  <button
                    onClick={(e) => {
                      togglePaymentVisibility(e);
                    }}
                  >
                    <DownAngelBracket
                      className={`h-[8px] text-1D4469 sidedownarrow  items-center ${
                        isPaymentTabOpen ? "" : "rotate-180"
                      }`}
                    />
                  </button>
                </div>
              </div>
              {isPaymentTabVisible && (
                <div className="p-5" ref={paymentTabRef}>
                  <div className="flex flex-col gap-y-[20px]">
                    <div className="w-full flex items-center space-x-4">
                      <div className="w-full flex flex-col gap-y-1">
                        <div className="text-14 font-400 text-434852">primary Payment Method</div>
                        <div className="w-full">
                          <Select
                            name="primarypaymethodselect"
                            options={selectPPMName} // Pass the options array
                            value={selectedValue} // Bind the selected value to the state
                            onChange={handlePPMSelectChange} // Handle the change event
                            placeholder={"Select Method"}
                            style={{
                              width: "100%",
                              height: "35px",
                              padding: "5px",
                            }}
                            className="w-full"
                          ></Select>
                        </div>
                      </div>

                      <div className=" w-full">
                        <div className="flex flex-col gap-y-1">
                          <div className="text-14 font-400 text-434852">Terms</div>

                          <div className="w-full">
                            <Select
                              name="paymenttermselect"
                              placeholder={"Select Term"}
                              options={selectPayTermsNames} // Pass the options array
                              value={selectePayTermValue} // Bind the selected value to the state
                              onChange={handlePayTermSelectChange} // Handle the change event
                              style={{
                                width: "100%",
                                height: "35px",
                                padding: "5px",
                              }}
                              className="w-full"
                            ></Select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="w-full flex items-center space-x-4">
                      <div className="w-full flex flex-col gap-y-1">
                        <div className="text-14 font-400 text-434852">Sales From Delivery Person</div>
                        <div className="w-full">
                          <Select
                            name="SalesFromdelivPErselect"
                            options={selectSalesFDPName} // Pass the options array
                            value={selectedSalesValue} // Bind the selected value to the state
                            onChange={handSalesFDPSelectChange} // Handle the change event
                            placeholder={"Select Name"}
                            style={{
                              width: "100%",
                              height: "35px",
                              padding: "5px",
                            }}
                            className="w-full"
                          ></Select>
                        </div>
                      </div>

                      <div className=" w-full">
                        <div className="flex flex-col gap-y-1">
                          <div className="text-14 font-400 text-434852">Language</div>

                          <div className="w-full">
                            <Select
                              name="vendordispalyselect"
                              placeholder={"Select Language"}
                              options={selectLanguage} // Pass the options array
                              value={selectedLanguageValue} // Bind the selected value to the state
                              onChange={handleLanguageSelectChange} // Handle the change event
                              style={{
                                width: "100%",
                                height: "35px",
                                padding: "5px",
                              }}
                              className="w-full"
                            ></Select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="w-full flex ">
                      <div className=" w-full flex flex-col gap-y-1">
                        <div className="text-14 font-400 text-434852 capitalize">Credit Limit</div>

                        <div>
                          <Input
                            name="credit limit"
                            // label="dkd"
                            type={"number"}
                            placeholder="Enter Limit"
                            value={inputCreditLimitValue}
                            onChange={handleCreditLimitInputChange}
                            style={{ width: "100%", height: "35px" }}
                          ></Input>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="border">
              <div className="flex justify-between items-center bg-E4E6E8 p-3 border">
                <div className="text-16 font-500">Additional Info</div>
                <div>
                  <button
                    onClick={(e) => {
                      toggleAddiInfVisibility(e);
                    }}
                  >
                    <DownAngelBracket
                      className={`h-[8px] text-1D4469 sidedownarrow  items-center ${
                        isAddiInfoTabOpen ? "" : "rotate-180"
                      }`}
                    />
                  </button>
                </div>
              </div>
              {isAddiInfoTabVisible && (
                <div className="p-3 pb-5" ref={additionalInfTabRef}>
                  <div className="flex flex-col gap-y-[20px]">
                    <div className="w-full flex items-center space-x-4">
                      <div className="w-full flex flex-col gap-y-1">
                        <div className="text-14 font-400 text-434852">Client Type</div>
                        <div className="w-full">
                          <Select
                            name="clienttypeselect"
                            options={selectClientType} // Pass the options array
                            value={selectedClietValue} // Bind the selected value to the state
                            onChange={handleClientTypeSelectChange} // Handle the change event
                            placeholder={"Select Method"}
                            style={{
                              width: "100%",
                              height: "35px",
                              padding: "5px",
                            }}
                            className="w-full"
                          ></Select>
                        </div>
                      </div>

                      <div className=" w-full">
                        <div className="flex flex-col gap-y-1">
                          <div className="text-14 font-400 text-434852">Terms</div>

                          <div className="w-full">
                            <Select
                              name="vendordispalyselect"
                              placeholder={"Select Terms"}
                              options={selectAddInfoTermNames} // Pass the options array
                              value={selecteAddInfTermValue} // Bind the selected value to the state
                              onChange={handleAddInfTermSelectChange} // Handle the change event
                              style={{
                                width: "100%",
                                height: "35px",
                                padding: "5px",
                              }}
                              className="w-full"
                            ></Select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="w-full flex items-center space-x-4">
                      <div className=" w-full">
                        <div className="flex flex-col gap-y-1">
                          <div className="text-14 font-600 text-2C495D">Taxes</div>
                        </div>
                      </div>
                    </div>

                    <div className="w-full flex items-center space-x-4">
                      <div className=" w-full flex flex-col gap-y-1">
                        <div className="text-14 font-400 text-434852">Exemption Detail</div>

                        <div>
                          <Input
                            name="exemptiondetail"
                            // label="dkd"
                            placeholder="Enter Detail"
                            value={inputExempDetailValue} // Bind the input value to the state
                            onChange={handleExempDetailChange} // Handle the change event
                            style={{ width: "100%", height: "35px" }} // Additional styling if needed
                          ></Input>
                        </div>
                      </div>
                    </div>

                    <div className="w-full flex items-center space-x-4">
                      <div className=" w-full">
                        <div className="flex flex-col gap-y-1">
                          <div className="text-14 font-600 text-2C495D">Opening Balance</div>
                        </div>
                      </div>
                    </div>
                    <div className="w-full flex items-center space-x-4">
                      <div className=" w-full">
                        <div className="flex flex-col gap-y-1">
                          <div className="text-14 font-400 text-434852">Opening Balance</div>

                          <div>
                            <Input
                              name="Opening_balance"
                              // label="Enter Text"
                              placeholder="00.00"
                              type={"number"}
                              value={inputOpeningBalace} // Bind the input value to the state
                              onChange={handleBankAccNumberInputChange} // Handle the change event
                              style={{ width: "100%", height: "35px" }} // Additional styling if needed
                            ></Input>
                          </div>
                        </div>
                      </div>
                      <div className=" w-full">
                        <div>
                          <div className="w-full flex flex-col gap-y-1">
                            <div className="text-14 font-400">As Of</div>
                            <div className="flex items-center bg-white   datePicker_container ">
                              <DatePicker
                                selected={OpeningBalanceDate}
                                onChange={onChange}
                                paymentDate={OpeningBalanceDate}
                                // endDate={endDate}
                                // selectsRange
                                placeholderText={placeholder}
                                dateFormat={displayFormat}
                                className=" w-[100%] flex-grow  rounded focus:outline-hidden focus:ring-0    active:border active:border-DFE2E5 text-gray-800 text-sm  h-[34px]  border border-gray-200"
                              ></DatePicker>

                              <div>
                                <CalendarWithTimeIcon></CalendarWithTimeIcon>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="p-4 h-[50px] text-14 font-400 ">
              <button className="text-16 font-500 flex flex-col items-center justify-center text-center">
                <span className="text-2999BC">Privacy</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewClient;
